import { ProgressCircle } from "@/components/common/progress-circle";
import { Button } from "@/components/ui/button";
import { ClinicalCaseSummaryContent } from "./components/clinical-case-summary-content";
import { createPath } from "@/service/routing/routing";
import { DrawPatientButton } from "../../../draw-patient-button";
import { Separator } from "@/components/ui/separator";

function getColor(value: number) {
  if (value <= 33) return "#F43F5E";
  if (value <= 66) return "#FB923C";
  if (value <= 100) return "#0d9488";
}

function getLabel(score: number) {
  if (score <= 33) return "Niestety";
  if (score <= 66) return "Dobrze";
  if (score <= 100) return "Gratulacje";
}

export const ClinicalCaseSummary = ({
  clinicalCase,
  score,
}: {
  clinicalCase: ClinicalCaseVM;
  score: ClinicalCaseClientQuizScore;
}) => {
  const { name } = clinicalCase;
  const questionCount = Object.keys(score).length;
  const correctCount = Object.values(score).filter((s) => s.correct).length;
  const incorrectCount = questionCount - correctCount;
  const finalScore = Math.round((correctCount / questionCount) * 100);

  return (
    <>
      <Separator className="my-21" />

      <header id="clinical-case-summary">
        <h2 className={`text-center text-xl font-semibold text-zinc-900`}>
          Wizyta zakończona
        </h2>
      </header>

      <div className="my-6 flex items-center justify-center rounded-[10px] border px-4 py-8">
        <div className={"flex max-w-[448px] items-center justify-center gap-8"}>
          <div className={"flex items-center"}>
            {finalScore != null && (
              <ProgressCircle
                percentage={finalScore}
                size={96}
                thickness={6}
                className={"text-lg"}
                color={getColor(finalScore)}
              />
            )}
          </div>
          <div className={"flex flex-col justify-center"}>
            <div className={`text-foreground mb-1 text-lg font-semibold`}>
              {getLabel(finalScore)}!
            </div>
            <div className={`text-foreground text-sm font-normal`}>
              Przypadek kliniczny {'"'}
              {name}
              {'"'} ukończony z wynikiem {finalScore}%.
            </div>
          </div>
        </div>
      </div>
      {finalScore != null && (
        <ClinicalCaseSummaryContent
          correct={correctCount}
          incorrect={incorrectCount}
          questionsCount={questionCount}
        />
      )}
      <div className={"mt-12 flex items-center justify-between"}>
        <Button asChild variant={"outline"}>
          <a href={createPath("clinical_case.index")}>Wróć do panelu</a>
        </Button>
        <DrawPatientButton variant={"blue"}>Losuj pacjenta</DrawPatientButton>
      </div>
    </>
  );
};
